import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api";
import type {
  BachecaVoce,
  BachecaVoceCreate,
  BachecaVoceUpdate,
} from "@/types/api";

export function useCreaBacheca() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: BachecaVoceCreate) =>
      apiFetch<BachecaVoce>("/api/v1/admin/bacheca", {
        method: "POST",
        body: JSON.stringify(body),
      }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["bacheca"] });
      qc.invalidateQueries({ queryKey: ["avanzamento"] });
    },
  });
}

interface AggiornaArgs {
  voceId: string;
  body: BachecaVoceUpdate;
}

export function useAggiornaBacheca() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ voceId, body }: AggiornaArgs) =>
      apiFetch<BachecaVoce>(`/api/v1/admin/bacheca/${voceId}`, {
        method: "PATCH",
        body: JSON.stringify(body),
      }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["bacheca"] });
    },
  });
}

interface ChiudiArgs {
  voceId: string;
  motivo_chiusura: string;
}

export function useChiudiBacheca() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ voceId, motivo_chiusura }: ChiudiArgs) =>
      apiFetch<BachecaVoce>(`/api/v1/admin/bacheca/${voceId}/chiudi`, {
        method: "POST",
        body: JSON.stringify({ motivo_chiusura }),
      }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["bacheca"] });
      qc.invalidateQueries({ queryKey: ["avanzamento"] });
    },
  });
}

export function useMarcaBachecaLetto() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (voceId: string) =>
      apiFetch<BachecaVoce>(`/api/v1/admin/bacheca/${voceId}/letto`, {
        method: "POST",
      }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["bacheca"] });
    },
  });
}
